
import {
  REQUEST_BILLING_COUNTS_FOR_PAST_6_MONTHS,
  REQUEST_BILLING_COUNTS_FOR_PAST_6_MONTHS_ERROR,
  RECEIVE_BILLING_COUNTS_FOR_PAST_6_MONTHS
} from 'actions'

export default function (state = {}, action) {
  const { type, payload } = action

  switch (type) {
    case REQUEST_BILLING_COUNTS_FOR_PAST_6_MONTHS:
      return {
        ...state,
        [payload.workspaceSlug]: {
          isRequesting: true,
          didRequestFail: false,
          didRequest: false,
          data: []
        }
      }
    case RECEIVE_BILLING_COUNTS_FOR_PAST_6_MONTHS:
      return {
        ...state,
        [payload.workspaceSlug]: {
          isRequesting: false,
          didRequestFail: false,
          didRequest: true,
          data: payload.data.reverse() // Switch to ascending order for the graph
        }
      }
    case REQUEST_BILLING_COUNTS_FOR_PAST_6_MONTHS_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          isRequesting: false,
          didRequestFail: true,
          didRequest: true,
          data: []
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/mtus/past-6-months.js